import {
  Card,
  ChartEmptyState,
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { SpaceAccessControl } from '@eggplant/context'
import type { CSSProperties } from 'react'

const chartEmptyStateWrapper: CSSProperties = {
  display: 'grid',
  height: '80px'
}

const SpaceNoMembers = () =>
  <div className='grid'>
    <div style={chartEmptyStateWrapper}>
      <Card>
        <ChartEmptyState title='No members added yet'>
          <SpaceAccessControl isHiddenIfDenied>
            <Paragraph>
              <Color variant='theme-filter-icon'>
                Please add member from the list on left.
              </Color>
            </Paragraph>
          </SpaceAccessControl>
        </ChartEmptyState>
      </Card>
    </div>
  </div>

export default SpaceNoMembers
